<app-dialog
  [title]="'graphEmbed.title' | translate"
  [confirmation]="'graphEmbed.applyFilters' | translate"
  (save)="applyFilters()"
  [isValid]="!loading"
>
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-12">
        <mat-label class="d-flex">{{ 'graphEmbed.parameters.sessionAccountUid' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-select
            multiple
            formControlName="sessionAccountUid"
            [placeholder]="'input.selectOption' | translate"
            [disabled]="loading || accounts.length === 1"
          >
            <mat-option *ngIf="accounts.length > 1" value="all" (click)="selectedAccountsChanged(true)">{{
              'input.all' | translate
            }}</mat-option>
            <mat-option *ngFor="let account of accounts" [value]="account.uid" (click)="selectedAccountsChanged()">{{
              account.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-label class="d-flex">{{ 'graphEmbed.parameters.type' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-select multiple formControlName="type" [placeholder]="'input.all' | translate">
            <mat-option value="New">{{ 'terms.dealType.new' | translate }}</mat-option>
            <mat-option value="Used">{{ 'terms.dealType.used' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-label class="d-flex">{{ 'graphEmbed.parameters.dynamicDate' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="dynamicDate"
            (selectionChange)="dynamicDateChanged()"
            [placeholder]="'input.optionalOption' | translate"
          >
            <mat-option *ngFor="let dynamicDate of dynamicDateRanges" [value]="dynamicDate">{{
              dynamicDate.title | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row" *ngIf="dynamicDateRangeIndex <= 0">
      <div class="col-6">
        <mat-label class="d-flex">{{ 'graphEmbed.parameters.startDate' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="date" formControlName="beginDate" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-label class="d-flex">{{ 'graphEmbed.parameters.endDate' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="date" formControlName="endDate" />
        </mat-form-field>
      </div>
    </div>
  </form>
</app-dialog>
